import { mapState } from 'vuex'
import lodash_pick from 'lodash/pick'
export default {
    computed: {
        ...mapState('dialog', [
            'personal'
            // ...
        ]),
        personalGuestInfoNoSend() {
            return this.personal.guestInfoNoSend
        }
    },
    watch: {
        personalGuestInfoNoSend: {
            handler(obj, oldVal) {
                obj = lodash_pick(obj, Object.keys(this.payload.model))
                Object.assign(this.payload.model, obj)
            },

            immediate: true
        }
        /*   'payload.model': {
            handler(val, oldVal) {
                this.$store.commit('dialog/setGuestInfoNoSend', val)
            },
            deep: true
        }*/
    },
    created() {},
    mounted() {},
    methods: {
        change(e) {
            this.$store.commit('dialog/setGuestInfoNoSend', this.payload.model)
        }
    }
}
